import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";

import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import Switch from "material-ui-next/Switch";
import Icon from "material-ui-next/Icon";
import { CNPJ } from "cpf_cnpj";

// import CircularProgress from 'material-ui-next/Progress/CircularProgress';
import Moment from "moment";
// import _ from 'lodash';

import {
  Loadable,
  Page,
  IconButton,
  DataTable,
  StyledButton,
  EntitySelector,
  If,
  DescriptionField
} from "components/support";

import style from "./style";
// import Filter from './filter';

import { withStyles } from "material-ui-next/styles";
import { colors } from "assets";

const Toggle = withStyles({
  bar: {
    backgroundColor: colors.switch.primary,
    opacity: 0.3
  },
  checked: {
    color: colors.switch.primary,
    transform: "translateX(14px)",
    "& + $bar": {
      backgroundColor: colors.switch.primary,
      opacity: 0.5
    }
  }
})(Switch);

class SupportCompanyShowView extends Component {
  config = {
    identifier: "id",
    columns: [
      {
        accessor: "uuid",
        show: false
      },
      {
        accessor: "company_uuid",
        show: false
      },
      {
        accessor: "name",
        Header: "Nome",
        align: "center"
      },
      {
        accessor: "username",
        Header: "Login",
        align: "center"
      },
      {
        accessor: "is_admin",
        Header: "Admin",
        align: "center",
        Cell: props => this.parseAdminField(props.original.is_admin),
        sortable: false
      },
      {
        accessor: "updated_at",
        Header: "Última atualização",
        align: "center",
        Cell: props => this.parseUpdatedField(props.original.updated_at),
        sortable: false
      },
      {
        id: "deleted",
        accessor: "deleted",
        Header: "Habilitar/Desabilitar",
        align: "center",
        Cell: props => this.parseSwitchField(props.row._original),
        sortable: false
      }
    ]
  };

  parseAdminField = is_admin => {
    return (
      <div className={this.props.className}>
        <If test={is_admin}>
          <div className="done-icon">
            <Icon>done</Icon>
          </div>
        </If>
        <If test={!is_admin}>
          <div className="close-icon">
            <Icon>close</Icon>
          </div>
        </If>
      </div>
    );
  };

  parseUpdatedField = updated_at => {
    const date = Moment(updated_at).format("LT - l");
    return <div>{date}</div>;
  };

  parseSwitchField = user => {
    const { presenter } = this.props;

    return (
      <div>
        <Toggle
          checked={!user.deleted}
          onChange={(_, checked) => presenter.onChangeSwitch(user, checked)}
        />
      </div>
    );
  };

  render() {
    const { viewModel, presenter, className } = this.props;

    // const { company, loading, users, order, pagination, plan, infoTest, sellablesTest, companiesOptions, cloneSelector } = viewModel;
    const {
      company,
      loading,
      users,
      order,
      pagination,
      plan,
      companiesOptions,
      cloneSelector
    } = viewModel;
    // const parseErrors = (errors) => {
    //   return _.map(errors, (field, key) => {
    //     return (<div key={key} style={{ marginBottom: 5 }} >{ `${field.key}: ${field.message}` }</div>)
    //   })
    // };

    // const parseErrorsCompany = (errors) => {
    //   return _.map(errors, (field, key) => {
    //     return (<div key={key} style={{ marginBottom: 5 }} >{ field }</div>)
    //   })
    // };

    // const parseSellablesErrors = (sellables) => {
    //   return _.map(sellables, (sellable, key) => {
    //     return (
    //       <div key={key} style={{ margin: "10px 0", cursor: 'pointer'}} onClick={() => {
    //         presenter.sellableEdit(sellable.uuid, company)
    //       }}>
    //         <Typography type="headline">{sellable.name}</Typography>
    //         <Typography type="title">{sellable.code}</Typography>
    //         <Typography type="subheading">{sellable.uuid}</Typography>
    //         <div style={{ padding: 10, backgroundColor: "#eee", border: "1px solid #ddd" }}>
    //           { parseErrors(sellable.error_fields) }
    //         </div>
    //       </div>
    //     )
    //   })
    // }

    return (
      <Loadable className={className} loading={loading}>
        <Page>
          <Row>
            <Col xs={12} md={6}>
              <Typography type="display1" className="pb-sm">
                <IconButton
                  icon="arrow_back"
                  onClick={() => presenter.onGoBack()}
                />
                {company ? company.slug || company.name : "Visualizar Empresa"}
              </Typography>
            </Col>
            <Col xs={12} md={6} style={{ textAlign: "right" }}>
              <StyledButton
                accent
                onClick={() => presenter.openCloneSelector()}
              >
                <Icon style={{ fontSize: 15 }}>library_add</Icon> Clonar painel
                da empresa
              </StyledButton>
            </Col>
          </Row>
          <EntitySelector
            hideField
            title="Selecione a empresa desejada"
            open={cloneSelector}
            searchOptions={companiesOptions}
            onSelect={company => presenter.onSelectCompany(company)}
            parser={company => ({
              key: company.uuid,
              title: company.slug,
              subtext: company.fiscal_informations
                ? CNPJ.format(company.fiscal_informations.cnpj)
                : ""
            })}
            onClose={() => presenter.closeCloneSelector()}
          />
          <Paper elevation={1} className="paper">
            <Row className="row">
              <Col xs={4}>
                <DescriptionField
                  fullWidth
                  value={company.name || ""}
                  label="Nome da Empresa"
                />
              </Col>
              <Col xs={4}>
                <DescriptionField
                  mask={[
                    /\d/,
                    /\d/,
                    ".",
                    /\d/,
                    /\d/,
                    /\d/,
                    ".",
                    /\d/,
                    /\d/,
                    /\d/,
                    "/",
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    "-",
                    /\d/,
                    /\d/
                  ]}
                  fullWidth
                  value={
                    company.fiscal_informations &&
                    company.fiscal_informations.cnpj
                      ? company.fiscal_informations.cnpj
                      : ""
                  }
                  label="CNPJ"
                />
              </Col>
              <Col xs={4}>
                <DescriptionField
                  fullWidth
                  value={plan ? plan.name : ""}
                  label="Plano"
                />
              </Col>
            </Row>
            <Row>
              <Col xs={6}>
                <DescriptionField
                  fullWidth
                  value={company.blocked ? "Bloqueado" : "Desbloqueado"}
                  label="Status"
                />
              </Col>
              <Col xs={6}>
                <DescriptionField
                  fullWidth
                  value={company.email || ""}
                  label="E-mail"
                />
              </Col>
            </Row>
          </Paper>

          {/*
          The filter is commented because it might be requested in the future
          <Row>
            <Col xs={12}>
              <Filter
                loading={loading}
                onFilter={(fields) => presenter.onFilterChange(fields)}
              />
            </Col>
          </Row>
          */}

          <Row>
            <Col className="company__content text-right company_qtd" xs={12}>
              <h3 className="user-found">
                {pagination.total} usuário(s) encontrado(s)
              </h3>
            </Col>
            <Col xs={12}>
              <Paper elevation={1} className="user__content">
                <DataTable
                  manual
                  filterable={false}
                  resultSet={users}
                  total={pagination.total}
                  perPage={pagination.perPage}
                  page={pagination.currentPage}
                  config={this.config}
                  onChange={({ field, value }) =>
                    presenter.onOrderChange(field, value)
                  }
                  orderField={order.field}
                  orderDirection={order.direction}
                  onPageChange={page => presenter.onPageChange(page + 1)}
                />
              </Paper>
            </Col>
          </Row>
          {/* <Paper elevation={1} style={{ padding: 15, margin: "10px 0" }} >
            <Row middle="xs" style={{ alignItems: "start" }}>
              <Col xs={8}>
                <Row>
                  <Col xs={12}>
                    <Typography type="display1" className="pb-sm">Testar Empresa</Typography>
                  </Col>
                  <Col xs={12}>

                    <If test={ infoTest.status === 'failed' } >
                      <Typography type="subheading" className="pb-sm" style={{ color: 'red' }}>
                        <Row style={{ padding: 10 }}>
                          <Col>
                            <Icon style={{ marginRight: 10 }}>highlight_off</Icon>
                          </Col>
                          <Col>
                            Houveram problemas ao validar os dados da empresa: {`${ company.slug || company.name }`}
                          </Col>
                        </Row>
                      </Typography>
                      
                      <div style={{ padding: 10, backgroundColor: "#eee", border: "1px solid #ddd" }}>
                        { parseErrorsCompany(infoTest.errors) }
                      </div>
                    </If>
                    <If test={ infoTest.status === 'in_progress' } >
                      <Typography type="subheading" className="pb-sm">
                        <Row style={{ padding: 10 }}>
                          <Col>
                            <Icon style={{ marginRight: 10 }}>sync</Icon>
                          </Col>
                          <Col>
                            Teste em andamento...
                          </Col>
                        </Row>
                      </Typography>
                    </If>
                    <If test={ infoTest.status === 'success' } >
                      <Typography type="subheading" className="pb-sm" style={{ color: 'green' }}> 
                        <Row style={{ padding: 10 }}>
                          <Col>
                            <Icon style={{ marginRight: 10 }}>check_circle_outline</Icon>
                          </Col>
                          <Col>
                            Todos os dados da empresa estão válidos
                          </Col>
                        </Row>
                     
                      </Typography>
                    </If>

                    <If test={ infoTest.status === '' } >
                      <Typography type="subheading" className="pb-sm">Testar todos os dados da empresa</Typography>
                    </If>

                  </Col>
                </Row>
              </Col>
              <Col xs={4} style={{ textAlign: 'center' }}>
                <Row center="xs" middle="xs">

                  <If test={ infoTest.status === 'in_progress' } >
                    <CircularProgress />
                  </If>

                  <If test={ infoTest.status !== 'in_progress' } >
                    <StyledButton
                      secondary
                      size='large'
                      label='TESTAR'
                      onTouchTap={() => { presenter.validateInfo(company.uuid) }}
                    />
                  </If>
                </Row>
              </Col>
            </Row>
          </Paper>
          <Paper elevation={1} style={{ padding: 15, margin: "10px 0" }} >
            <Row middle="xs" style={{ alignItems: "start" }}>
              <Col xs={8}>
                <Row>
                  <Col xs={12}>
                    <Typography type="display1" className="pb-sm">Testar Produtos</Typography>
                  </Col>
                  <Col xs={12}>
                  <If test={ sellablesTest.status === 'failed' } >
                      <Typography type="subheading" className="pb-sm" style={{ color: 'red' }}>
                        <Row style={{ padding: 10 }}>
                          <Col>
                            <Icon style={{ marginRight: 10 }}>highlight_off</Icon>
                          </Col>
                          <Col>
                            Houveram problemas ao validar os dados da empresa: {`${ company.slug || company.name }`}
                          </Col>
                        </Row>
                      </Typography>
                      
                      { parseSellablesErrors(sellablesTest.errors) } 
                    </If>
                    <If test={ sellablesTest.status === 'in_progress' } >
                      <Typography type="subheading" className="pb-sm">
                        <Row style={{ padding: 10 }}>
                          <Col>
                            <Icon style={{ marginRight: 10 }}>sync</Icon>
                          </Col>
                          <Col>
                            Teste em andamento...
                          </Col>
                        </Row>
                      </Typography>
                    </If>
                    <If test={ sellablesTest.status === 'success' } >
                      <Typography type="subheading" className="pb-sm" style={{ color: 'green' }}> 
                        <Row style={{ padding: 10 }}>
                          <Col>
                            <Icon style={{ marginRight: 10 }}>check_circle_outline</Icon>
                          </Col>
                          <Col>
                            Todos os dados dos produtos da empresa {`${ company.slug || company.name }`} estão válidos
                          </Col>
                        </Row>
                     
                      </Typography>
                    </If>

                    <If test={ sellablesTest.status === '' } >
                      <Typography type="subheading" className="pb-sm">Testar todos os produtos da empresa</Typography>
                    </If>
                    <If test={ sellablesTest.nfce_emission === 'pending' } >
                      <Typography type="subheading" className="pb-sm">Fazendo emissão de NFCe's em Homologação dos produtos válidos</Typography>
                    </If>

                    <If test={ sellablesTest.nfce_emission === 'done' } >
                      <Typography type="subheading" className="pb-sm">Emissão de NFCe em Homologação Finalizada</Typography>
                    </If>

                    <If test={ sellablesTest.nfces && sellablesTest.nfces.length > 0 } >
                      
                      <div>
                        {
                          sellablesTest.nfces ? sellablesTest.nfces.map(({nfce_id, status, xml_url, sellable, response}) => {
                            return (
                              <div key={nfce_id} style={{ margin: "8px 0" }} >
                                <Typography type="headline">{sellable.name}</Typography>
                                <Typography type="title">{sellable.code}</Typography>
                                <Typography type="subheading">{sellable.uuid}</Typography>
                                <div style={{ padding: 8, background: '#eee', border: "1px solid #ddd", margin: "8px 0" }}>
                                  <Typography type="subheading" className="pb-sm" style={{ color: status === 'succeeded' ? 'green' : 'red' }}><Icon> {status === 'succeeded' ?  'check_circle_outline' : 'highlight_off'} </Icon> {status === 'succeeded' ? 'Sucesso' : 'Falhou'}</Typography>
                                  <Typography type="subheading" className="pb-sm">Emites NFCe ID: {nfce_id}</Typography>
                                  {
                                    xml_url ? 
                                      (<Typography type="subheading" className="pb-sm">
                                        <a href={xml_url} target="_blank" rel="noopener noreferrer">
                                          Ver XML da NFCe
                                        </a>
                                      </Typography>)  
                                    : null
                                  }

                                  { status === 'rejected' && response.erros ? 
                                    response.erros.map(error => (
                                      <Typography type="subheading" className="pb-sm">
                                        { error }
                                      </Typography>
                                    ))
                                    : null
                                  }
                                </div>
                              </div>
                            )
                          }) : null
                        }
                      </div>
                    </If>


                  </Col>
                </Row>
              </Col>
              <Col xs={4}>
                <Row center="xs" middle="xs">
                  <If test={ sellablesTest.status === 'in_progress' || sellablesTest.nfce_emission === 'pending'} >
                    <CircularProgress />
                  </If>

                  <If test={ sellablesTest.status !== 'in_progress' && sellablesTest.nfce_emission !== 'pending' } >
                    <StyledButton
                      secondary
                      size='large'
                      label='TESTAR'
                      onTouchTap={() => { presenter.validateSellables(company.uuid) }}
                    />
                  </If>
                </Row>
              </Col>
            </Row>
          </Paper> */}
        </Page>
      </Loadable>
    );
  }
}

export default style(SupportCompanyShowView);



// WEBPACK FOOTER //
// ./src/components/app/support/company/company-show/view.jsx